import React, { useEffect, useRef, useState } from 'react'
import { Alert, Backdrop, Box, Button, Card, CardContent, CircularProgress, Fab, Icon, IconButton, Snackbar, Typography } from '@mui/material'
import { grey } from '@mui/material/colors'
import { useAppSelector } from '../../app/hooks'
import { selectDomainCss } from '../analysis/AnalysisSlice'

export interface IconBox2Prop {
  icon?: string      // "/logo/logo-1024.png"
  title: string     // Rentfinder
  subtitle: string  // powered by Rentfinder™
  width?: string
  showEdit?: boolean
  onEdit?: () => void
}

function IconBox2(prop: IconBox2Prop) {
  const domainCss = useAppSelector(selectDomainCss)
  return (
    <Box component="div" sx={{ textAlign: 'left' }}>
      {prop.showEdit && <Button className='print-hide' onClick={prop.onEdit} sx={{ float: 'right' }}
        variant="text" color="primary" size="small">
        Edit
      </Button>}
      <Typography component="div" variant='caption' sx={{ color: grey[500] }}>
        {prop.title}
      </Typography>
      <Box component="div" sx={{ textAlign: 'left', mr: 1, display: 'inline-flex' }}>
        <img src={prop.icon} width="14" style={{ alignSelf: 'end' }} />
      </Box>
      <Box component="div" sx={{ textAlign: 'left', display: 'inline-flex' }}>
        <Typography component="span" variant='body1' sx={{ alignSelf: 'end' }}>
          <strong>{prop.subtitle}</strong>
        </Typography>
      </Box>
    </Box >
  )
}

export default IconBox2